module.exports = __webpack_public_path__ + "media/images/registration/public_user-7b1a0c084f5dc71780df7c4aa673864c.png";